import React from 'react';
import {
  Button,
  Card,
  Description,
  Discount,
  Free,
  Pic,
  Price,
  PriceText,
  Title,
  Wrapper,
  WrapperPrice,
} from './styled';
import { connect } from 'react-redux';
import PopupCallback from '@ertelecom/ui-react/components/popups/popupCallback';
import PopupResult from '@ertelecom/ui-react/components/popups/popupResult';
import { declOfNum } from '@ertelecom/ui-react/components/helpers';

const monthText = declOfNum(['месяц', 'месяца', 'месяцев']);


class LotCard extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      orderStatus: false,
      isOpen: false,
      hasResult: false,
      resultTitle: '',
      resultDescription: '',
      resultClass: '',
      buttonDisable: false
    };
  }

  handleClose = () => {
    this.setState({
      isOpen: false
    });
  }

  percentCount = (price, promoPrice) => {
    const NewPrice = price.replace(/,/g, '.');
    const NewPromoPrice = promoPrice.replace(/,/g, '.');
    const percent = 100 - (100 * parseFloat(NewPromoPrice) / parseFloat(NewPrice));
    return ('-' + Math.round(percent) + '%');
  }

  getOptions = (data) => {
    const options = [];
    if (data.month) {
      options.push({
        value: 'month',
        label: 'подписка на 1 мес.',
        price: data.month,
        operType: 'rent'
      });
    }
    if (data.year) {
      options.push({
        value: 'year',
        label: 'подписка на 1 год.',
        price: data.year,
        operType: 'rent'
      });
    }
    return options;
  }

  changeOptions = (option) => {
    this.setState({
      selectedOption: option,
    });
  }

  onSuccess = () => {
    this.setState({
      hasResult: true,
      resultTitle: 'Заявка отправлена успешно',
      resultDescription: 'Мы с вами свяжемся',
      resultClass: 'success'
    }, () => {
      this.setState({
        isOpen: false,
        orderStatus: true,
      });
    });
  }

  onFailure = () => {
    const text = 'Попробуйте позже';
    this.setState({
      hasResult: true,
      resultTitle: 'Заявка не отправлена',
      resultDescription: text,
      resultClass: 'error'
    }, () => {
      this.setState({
        orderStatus: false,
        isOpen: false
      });
    });
  }

  lotOrder = () => {
    const { buttonLink } = this.props;
    if (buttonLink) {
      window.location.href = buttonLink;
    } else {
      window.location.href += '#request';
    }
  }


  setButtonText = () => {
    const { orderStatus } = this.state;
    const { buttonText, buttonTextExists, exist } = this.props;
    if (!exist) {
      return !orderStatus ? buttonText : buttonTextExists;
    }
    return buttonTextExists;
  }

  checkButtonStatus = (text) => {
    return text === this.state.buttonStatus;
  }

  getRALifeTime = (time) => {
    time++;
    return time;
  }

  render() {
    const { orderStatus, isOpen, resultTitle, resultDescription, resultClass, hasResult, buttonDisable } = this.state;
    const { description, name, price, image, orderId, exist, buttonText, data, pricesPromo, buttonLink } = this.props;
    return (
      <React.Fragment>
        <Card>
          <Pic background={`url(${image})`}/>
          <Title>
            {name}
          </Title>
          {pricesPromo.rent.month &&
          <Free>
            {pricesPromo.rent.month.lifetime_price > 1 ? 'первые' : 'первый'}
            &nbsp;{pricesPromo.rent.month.lifetime_price}
            &nbsp;{monthText(pricesPromo.rent.month.lifetime_price)}
            &nbsp;{pricesPromo.rent.month.value}₽/мес.
            <Discount>
              {this.percentCount(data.month, pricesPromo.rent.month.value)}
            </Discount>
          </Free>}
          <WrapperPrice>
            <Wrapper>
              {buttonLink ? <>
                <Price>
                  {buttonLink ? price : data.month ? data.month : data.year}
                </Price>
                {data.month || data.year || price
                  ? <PriceText>
                    {'₽'}
                    {pricesPromo.rent.month ? <> - c {this.getRALifeTime(pricesPromo.rent.month.lifetime_price)}-го
                      месяца</> : null}
                  </PriceText> : null}
              </> : <PriceText>Сумму установки уточняйте при заказе</PriceText>}
            </Wrapper>
          </WrapperPrice>
          <Description dangerouslySetInnerHTML={{ __html: description }}/>
          <Button text={this.setButtonText()} type={orderStatus ? 'secondary' : 'primary'}
                  disabled={orderStatus || this.checkButtonStatus(buttonText) || exist || buttonDisable}
                  onClick={() => this.lotOrder(orderId)}/>
        </Card>
        <PopupCallback
          isOpen={isOpen}
          onClose={this.handleClose}
          city={this.props.currentCity}
          onSuccessShow={this.onSuccess}
          onFailureShow={this.onFailure}
          label='InternetOrder'
        />
        <PopupResult
          isOpen={hasResult}
          onClose={() => {
            this.setState({ hasResult: false });
          }}
          title={resultTitle}
          text={resultDescription}
          type={resultClass}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  currentCity: state.city.currentCity,
});

export default connect(mapStateToProps)(LotCard);
